/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const SpeciesStatus = {
    Ok: 'OK',
    NoFish: 'NO_FISH',
    Error: 'ERROR',
} as const;
export type SpeciesStatus = typeof SpeciesStatus[keyof typeof SpeciesStatus];


export function instanceOfSpeciesStatus(value: any): boolean {
    for (const key in SpeciesStatus) {
        if (Object.prototype.hasOwnProperty.call(SpeciesStatus, key)) {
            if (SpeciesStatus[key as keyof typeof SpeciesStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SpeciesStatusFromJSON(json: any): SpeciesStatus {
    return SpeciesStatusFromJSONTyped(json, false);
}

export function SpeciesStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): SpeciesStatus {
    return json as SpeciesStatus;
}

export function SpeciesStatusToJSON(value?: SpeciesStatus | null): any {
    return value as any;
}

export function SpeciesStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): SpeciesStatus {
    return value as SpeciesStatus;
}

